import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import List from '@/views/List'
import Detail from '@/views/Detail'
import Personal from '@/views/user/Personal'
import AddPosts from '@/views/user/addPosts'
import AddVideo from '@/views/user/addVideo'
import AddActivity from '@/views/user/addActivity'
import Login from '@/views/Login'
import PersonalFollow from '@/views/user/personalFollow'
import PersonalFans from '@/views/user/personalFans'
import PersonalCollect from '@/views/user/PersonalCollect'
import PersonalLike from '@/views/user/PersonalLike'
import PersonalVisit from '@/views/user/PersonalVisit'
import personalInformation from '@/views/user/personalInformation'
import personalSetting from '@/views/user/personalSetting'
import personalHelp from '@/views/user/personalHelp'
import UserCenter from '@/views/UserCenter'
import MDetail from '@/views/m/Detail'
import MNewsDetail from '@/views/m/NewsDetail'
import MNewDetail from '@/views/m/Ndetail'
import Search from '@/views/Search'
import Agreement from '@/views/Agreement'
import Error404 from '@/views/404'
import MSignList from '@/views/m/SignList'
import Download from '@/views/m/Download'
import Topic from '@/views/Topic'
import MTopic from '@/views/m/Topic'
import MLogin from '@/views/m/Login'
import MAgreement from '@/views/m/Agreement'
import MSpecial from '@/views/m/Special'

Vue.use(Router)
const router = new Router({
  // 设置路由模式为‘history’，去掉默认的#
  mode: "history",
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/login/',
      component: Login
    },
    {
      path: '/list/:cid/:targetType',
      component: List
    },
    {
      path: '/detail/:id/:targetType',
      component: Detail
    },
    {
      path: '/usercenter/:id',
      component: UserCenter
    },
    {
      path: '/user/personal/:id',
      component: Personal
    },
    {
      path: '/user/personalfollow',
      component: PersonalFollow
    },
    {
      path: '/user/personalfans',
      component: PersonalFans
    },
    {
      path: '/user/personalCollect',
      component: PersonalCollect
    },
    {
      path: '/user/personallike',
      component: PersonalLike
    },
    {
      path: '/user/personalvisit',
      component: PersonalVisit
    },
    {
      path: '/user/personalinformation',
      component: personalInformation
    },
    {
      path: '/user/personalsetting',
      component: personalSetting
    },
    {
      path: '/user/personalhelp',
      component: personalHelp
    },
    {
      path: '/user/posts/:type',
      name:"发文章",
      component: AddPosts,
    },
    {
      path: '/user/video/:type',
      name:"发视频",
      component: AddVideo
    },
    {
      path: '/user/activety/:type',
      name:"发活动",
      component: AddActivity
    },
    {
      path: '/m/detail/:id/:type',
      name:"app文章详情",
      component: MDetail
    },
    {
      path: '/m/newsdetail/:id/:type',
      name:"app新闻详情",
      component: MNewsDetail
    },
    {
      path: '/m/newdetail/:id/:type',
      name:"新app新闻详情",
      component: MNewDetail
    },
    {
      path: '/search',
      name:"检索页",
      component: Search
    },
    {
      path: '/agreement/:type',
      name:"协议",
      component: Agreement
    },
    {
      path: '/404',
      name:"404",
      component: Error404
    },
    {
      path: '/m/signlist/:id',
      name:"app签到列表",
      component: MSignList
    },
    {
      path: '/m/download',
      name:"app下载页面",
      component: Download
    },
    {
      path: '/topic/:id',
      name:"话题列表页面",
      component: Topic
    },
    {
      path: '/m/topic/:id',
      name:"话题列表页面",
      component: MTopic
    },
    {
      path: '/m/Login',
      name: "客户端登录页面",
      component: MLogin
    },
    {
      path: '/m/Agreement/:type',
      name: "协议",
      component: MAgreement
    },
    {
      path: '/m/special/:id',
      name: "专题",
      component: MSpecial
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path.includes("/m/")){
    document.title="大河网"
  }else{
    document.title="大河网"
  }
  // 获取用户信息
  const userToken = localStorage.getItem('UserToken');
  // 判断目标路由是否匹配 /user/* 目录
  if (to.path.startsWith('/user/') && !userToken) {
    next({ path: '/login' });
  } else {
    next();
  }
  
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js